export interface ActionType{
  title: string;
  tipo: string;
}

export const UPDATE:ActionType = {
  title:"Editar Costo Usuario",
  tipo:"U"
}

export const CREATE: ActionType = {
  title:"Nuevo Costo",
  tipo:"I"
}

export const DELETE: ActionType = {
  title:"",
  tipo:"D"
}

export const UPLOAD_CA: ActionType = {
  title:"Importación Costo Anual",
  tipo:"UFCA"
}

export const UPLOAD_CP: ActionType = {
  title:"Importación CP / Indirectos",
  tipo:"UFCP"
}